import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { useMemo, useCallback } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { CUSTOM_REPORT } from '@signal/routes';
import isStorybook from '@signal/utils/env/isStorybook';
import isTest from '@signal/utils/env/isTest';
import UnknownReportError from '@signal/utils/errors/UnknownReportError';
import isValidGuid from '@signal/utils/isValidGuid';
import parseDate from '@signal/utils/parseDate';
import { DATE_RANGE_TYPE_COMPARISON, DATE_RANGE_TYPE_PRIMARY, QP_DATE_START, QP_DATE_END, QP_FILTERS, SUBST_DATE_RANGE_TYPE } from './queryParamManager/constants';
import { applyGlobalQPs, getManagedQP, getManagedQPs } from './queryParamManager';
import { userIdSelector } from '../user';
import useReport, { cacheReport } from './useReport';
import useSlugService from './slugService';
import redirectOldReports from './slugService/redirects';
import { getReportIdFromSlugs } from './slugService/utils';
import { mapFiltersToArray } from './utils';
/**
 * Use this function to find and reshape active filters from filterOptions;
 * referred to as filterCategories here for better intuition.
 * @param {Array<Object>} filterCategories E.g. Condition, Make, Model, etc
 * @returns Active Filters with Custom Structure
 */

function getActiveFiltersFromFilterCategories(filterCategories) {
  return filterCategories.reduce(function (activeFilters, filterCategory) {
    filterCategory.options.filter(function (filterItem) {
      return filterItem.active === true;
    }).forEach(function (filterItem) {
      activeFilters.push({
        name: filterCategory.name,
        required: filterCategory.required,
        value: filterItem.value,
        valueDisplay: filterItem.display || filterItem.value
      });
    });
    return activeFilters;
  }, []);
} //
// hook exports below this line
//

/**
 * use this to get the account id from the route
 */


export function useRouteAccountId() {
  var match = useRouteMatch();
  return get(match, 'params.accountId');
}
/**
 * use this to get the global report filters from the route
 */

export function useRouteActiveFilters() {
  var _useLocation = useLocation(),
      search = _useLocation.search;

  return useMemo(function () {
    return getManagedQP({
      qpType: QP_FILTERS,
      search: search,
      defaultValue: '[]'
    });
  }, [search]);
}
/**
 * use the date range in the route, if any.  You can specify which range (date, comparison) and a override value
 */

export function useRouteDateRange(dateRangeType, overrideValue) {
  var _useLocation2 = useLocation(),
      search = _useLocation2.search;

  return useMemo(function () {
    // TODO this is being called unnecessarily when the sidenav expands. why?
    var _ref = overrideValue || {},
        oStart = _ref.startDate,
        oEnd = _ref.endDate;

    var overrideDates = oStart && oEnd && [parseDate(oStart), parseDate(oEnd)];

    var _ref2 = overrideDates || getManagedQPs({
      qpTypes: [QP_DATE_START, QP_DATE_END],
      search: search,
      substParams: _defineProperty({}, SUBST_DATE_RANGE_TYPE, dateRangeType)
    }),
        _ref3 = _slicedToArray(_ref2, 2),
        startDate = _ref3[0],
        endDate = _ref3[1];

    return startDate && endDate ? {
      startDate: startDate,
      endDate: endDate
    } : null;
  }, [overrideValue, search, dateRangeType]);
}
/**
 * Get the report id from the slug mapping if it exists. Otherwise,
 * assume the reportSlug is actually the id.
 */

export function useRouteReportId() {
  var _useParams = useParams(),
      sharedReportId = _useParams.sharedReportId,
      reportSlug = _useParams.reportSlug,
      subReportSlug = _useParams.subReportSlug;

  var accountId = useRouteAccountId(); // isTest() and isStorybook() will always return the same values for the entire session,
  // so this is not a true violation
  // eslint-disable-next-line react-hooks/rules-of-hooks

  var userId = isTest() || isStorybook() ? 'foo' : useSelector(userIdSelector);
  var serviceSlugs = useSlugService({
    accountId: accountId,
    userId: userId
  });

  var _useRouteMatch = useRouteMatch(),
      path = _useRouteMatch.path;

  var history = useHistory();
  var location = useLocation(); // redirect any legacy report URLs to conform to menu service

  redirectOldReports(accountId, history, location, path);
  return useMemo(function () {
    var reportSlugUse = reportSlug;
    var subReportSlugUse = subReportSlug; // default to 'overview' if a report slug is missing

    if (!reportSlugUse) {
      reportSlugUse = 'overview-v2';
    }

    if (reportSlugUse === CUSTOM_REPORT) {
      // TODO: we can support sub-report slugs for custom reports, but to do so we need to map the reportSlug to an
      // appropriate guid here
      reportSlugUse = userId || 'overview-v2';
      subReportSlugUse = '';
    }

    if (sharedReportId) {
      reportSlugUse = sharedReportId;
      subReportSlugUse = '';
    } // if the params contain a subreport slug, use it. otherwise just use the report slug


    var slug = subReportSlugUse ? "".concat(reportSlugUse, ":").concat(subReportSlugUse) : reportSlugUse; // get the report id from the slug alias, or use the report id if its a valid guid

    var reportId = getReportIdFromSlugs({
      serviceSlugs: serviceSlugs,
      activeSlugs: subReportSlugUse ? [reportSlugUse, subReportSlugUse] : [reportSlugUse]
    });

    if (reportId) {
      return reportId;
    }

    if (isValidGuid(slug) || isTest() || isStorybook()) {
      return slug;
    }

    throw new UnknownReportError(slug);
  }, [reportSlug, serviceSlugs, sharedReportId, subReportSlug, userId]);
}
/**
 * use this to get the context of the report, as determined from the route
 */

export function useRouteReportContext() {
  var accountId = useRouteAccountId();
  var reportId = useRouteReportId();
  var routeActiveFilters = useRouteActiveFilters();
  var routeDateRange = useRouteDateRange(DATE_RANGE_TYPE_PRIMARY);
  return {
    accountId: accountId,
    reportId: reportId,
    routeActiveFilters: routeActiveFilters,
    routeDateRange: routeDateRange
  };
}
/**
 * use this to get the actual report from the endpoint, based on the context in the route
 */

export function useRouteReportRevision() {
  var history = useHistory();
  var location = useLocation();

  var _useRouteReportContex = useRouteReportContext(),
      accountId = _useRouteReportContex.accountId,
      reportId = _useRouteReportContex.reportId,
      routeActiveFilters = _useRouteReportContex.routeActiveFilters,
      routeDateRange = _useRouteReportContex.routeDateRange; // request the report variant an filter options


  var report = useReport({
    accountId: accountId,
    activeFilters: routeActiveFilters,
    dateRange: routeDateRange,
    reportId: reportId
  });

  var _ref4 = report || {},
      _ref4$filters = _ref4.filters,
      filterOptions = _ref4$filters === void 0 ? [] : _ref4$filters,
      _ref4$dashboard = _ref4.dashboard,
      dashboard = _ref4$dashboard === void 0 ? {} : _ref4$dashboard;

  var activeFilters = useMemo(function () {
    return getActiveFiltersFromFilterCategories(filterOptions);
  }, [filterOptions]);
  var dateRange = useRouteDateRange(DATE_RANGE_TYPE_PRIMARY, dashboard);
  var comparisonDateRange = useRouteDateRange(DATE_RANGE_TYPE_COMPARISON);

  if (dashboard.dateOption !== 'rangeWithComparison' && //HACK: We need to support comparison on the overview report
  // even if the backend says we shouldn't.
  reportId !== 'e32fb8aa-9ab9-4edb-ba71-3339a34fb6a3') {
    comparisonDateRange = null;
  }
  /**
   * Expects a filter object right now. E.G. { Condition:  'New' }
   */


  var navigateTo = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(filters) {
      var newRange,
          newComparisonRange,
          pathname,
          search,
          queryParamString,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newRange = _args.length > 1 && _args[1] !== undefined ? _args[1] : dateRange;
              newComparisonRange = _args.length > 2 && _args[2] !== undefined ? _args[2] : comparisonDateRange;
              _context.next = 4;
              return cacheReport({
                accountId: accountId,
                activeFilters: filters,
                dateRange: newRange,
                reportId: reportId
              });

            case 4:
              pathname = location.pathname, search = location.search;
              queryParamString = applyGlobalQPs({
                comparisonDateRange: newComparisonRange,
                dateRange: newRange,
                filters: filters,
                search: search,
                // ensure we carry over any non-global params since we are saying on this report, just changing some global
                // filters
                excludeNonGlobalParams: false
              });
              history.push(pathname + queryParamString);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [accountId, comparisonDateRange, dateRange, history, location, reportId]);
  var setFilters = useCallback(function (filters) {
    return navigateTo(mapFiltersToArray(filters));
  }, [navigateTo]);
  var setDateRanges = useCallback(function (range, comparisonRange) {
    navigateTo(mapFiltersToArray(activeFilters), range, comparisonRange);
  }, [activeFilters, navigateTo]);
  return {
    accountId: accountId,
    activeFilters: activeFilters,
    comparisonDateRange: comparisonDateRange,
    dateRange: dateRange,
    dashboard: dashboard,
    filterOptions: filterOptions,
    report: report,
    reportSlug: reportId,
    setFilters: setFilters,
    setDateRanges: setDateRanges
  };
}
export default useRouteReportRevision;